/**
 * Fragrance finder quiz: accumulates one tag per question, then matches
 * the accumulated tag set against merchant-configured result rules
 * (section.blocks type "result_rule"). Falls back to the section's
 * default_result_link when no rule matches — never invents a product.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-fragrance-finder]').forEach(function (root) {
    var questions = root.querySelectorAll('[data-finder-question]');
    var stepDots = root.querySelectorAll('[data-finder-steps] .fragrance-finder__step-dot');
    var resultPanel = root.querySelector('[data-finder-result]');
    var rulesScript = root.querySelector('[data-finder-rules]');
    var rules = [];
    try { rules = rulesScript ? JSON.parse(rulesScript.textContent) : []; } catch (e) { rules = []; }

    var selectedTags = [];
    var currentQuestion = 0;

    function showQuestion(index) {
      questions.forEach(function (q, i) { q.classList.toggle('is-active', i === index); });
      stepDots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      currentQuestion = index;
    }

    function showResult() {
      questions.forEach(function (q) { q.classList.remove('is-active'); });
      var best = null;
      var bestScore = 0;
      rules.forEach(function (rule) {
        var score = rule.tags.filter(function (t) { return selectedTags.indexOf(t.trim()) > -1; }).length;
        if (score > bestScore) { bestScore = score; best = rule; }
      });

      var heading = resultPanel.querySelector('[data-finder-result-heading]');
      var text = resultPanel.querySelector('[data-finder-result-text]');
      var link = resultPanel.querySelector('[data-finder-result-link]');

      if (best) {
        if (heading) heading.textContent = best.title;
        if (text) text.textContent = best.text;
        if (link) link.href = best.url;
      } else if (text) {
        text.textContent = "Découvrez notre collection complète pour trouver votre parfum idéal.";
      }
      resultPanel.classList.add('is-active');
    }

    root.addEventListener('click', function (e) {
      var option = e.target.closest('[data-finder-option]');
      if (option) {
        selectedTags.push(option.getAttribute('data-tag'));
        if (currentQuestion < questions.length - 1) {
          showQuestion(currentQuestion + 1);
        } else {
          showResult();
        }
        return;
      }
      if (e.target.closest('[data-finder-restart]')) {
        selectedTags = [];
        resultPanel.classList.remove('is-active');
        showQuestion(0);
      }
    });

    if (questions.length) showQuestion(0);
  });
})();
